import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import { widgetCardClass, widgetTitleClass } from '../../dashboard/themeHelpers';
import { zoneCardClass, zoneDotClass, type HealthZone, type OpsIntensity } from '../theme';

interface SectionCardProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  zone?: HealthZone;
  intensity?: OpsIntensity;
}

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  subtitle,
  action,
  children,
  className,
  zone,
  intensity = 'admin',
}) => {
  const { colors } = useTheme();

  return (
    <section
      className={cn(
        widgetCardClass(colors, false, 'p-5 md:p-6'),
        zone && zoneCardClass(zone, intensity),
        className,
      )}
    >
      <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            {zone && <span className={zoneDotClass(zone)} aria-hidden />}
            <h3 className={widgetTitleClass(colors, 'lg')}>{title}</h3>
          </div>
          {subtitle && <p className={cn('text-sm mt-1', zone ? 'ml-4' : '', colors.textMuted)}>{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
};

export default SectionCard;
